import api from "./api";
import { Lotacao, UnidadeRegional, Diretoria, Superintendencia, InstituicaoEstadual, AreaAtuacao, DadoComplementarDefault } from "types/DadoComplementar";
import { InstitutionType } from "types/Parceiros";

export type FiltroRelacionamentoCampo = {
  field: string;
  operator: "=" | "!=";
  value?: string | number | boolean | null;
  source_field?: string;
};

export type RelacionamentoCampo = {
  categoria: string;
  source_field: string;
  source_value_id: number | null;
  aplicar_para_todos?: boolean | number | null;
  target_field: string;
  target_label: string;
  options_table: string;
  options_filters?: FiltroRelacionamentoCampo[];
  ordem?: number | null;
  obrigatorio?: boolean | number | null;
};

export async function findRelacionamentosCampos(categoria: string): Promise<RelacionamentoCampo[]> {
  const response = await api.get("/dados_complementares/relacionamentos-campos", {
    params: { categoria },
  });

  const payload = response.data;
  if (Array.isArray(payload)) return payload as RelacionamentoCampo[];
  if (payload && typeof payload === "object" && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: RelacionamentoCampo[] }).data;
  }

  return [];
}


export async function findAllLotacoes(): Promise<Lotacao[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/lotacoes`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar lotações:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar lotações"
    );
  }
}

export async function findAllUnidadesRegionais(): Promise<UnidadeRegional[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/unidades`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar unidades regionais:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar unidades regionais"
    );
  }
}

export async function findAllDiretorias(tipo?: string, superintendencia_id?: number): Promise<Diretoria[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/diretorias`;

  try {

    const response = await api.get(apiUrl, {
      params: {
        tipo,
        superintendencia_id,
      }
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar diretorias:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar diretorias"
    );
  }
}

export async function findAllSuperintendencias(): Promise<Superintendencia[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/superintendencias`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar superintendencias:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar superintendencias"
    );
  }
}

export async function findAllInstituicoesEstaduais(): Promise<InstituicaoEstadual[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/instituicoes_estaduais`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar instituições estaduais:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar instituições estaduais"
    );
  }
}

export async function findAllAreasAtuacao(): Promise<AreaAtuacao[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/areas_atuacao`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar áreas de atuação:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar áreas de atuação"
    );
  }
}

export async function findAllOrgaosAtuacao(): Promise<DadoComplementarDefault[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/orgaos_atuacao`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar órgãos de atuação:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar órgãos de atuação"
    );
  }
}

export async function findAllFuncoesDesempenhadas(): Promise<DadoComplementarDefault[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/funcoes_desempenhadas`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar as funções desempenhadas:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar as funções desempenhadas"
    );
  }
}

export async function findAllVinculosEmpregaticios(): Promise<DadoComplementarDefault[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/vinculos_empregaticios`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar os vínculos empregatícios:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar os vínculos empregatícios"
    );
  }
}

export async function findAllTiposInstituicao(): Promise<InstitutionType[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/dados_complementares/tipos_instituicao`;

  try {

    const response = await api.get(apiUrl);

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar tipos de instituicao:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar tipos de instituicao"
    );
  }
}
